export type QuantityType = 'CountBased' | 'VolumeBased' | 'WeightBased';

export type UnitOfMeasure = {
  QuantityType: QuantityType;
  Name: string;
  Abbreviation: string;
};

export const UNITS_OF_MEASURE: UnitOfMeasure[] = [
  { QuantityType: 'CountBased', Name: 'Each', Abbreviation: 'ea' },
  { QuantityType: 'VolumeBased', Name: 'Fluid Ounces', Abbreviation: 'fl oz' },
  { QuantityType: 'VolumeBased', Name: 'Gallons', Abbreviation: 'gal' },
  { QuantityType: 'WeightBased', Name: 'Grams', Abbreviation: 'g' },
  { QuantityType: 'WeightBased', Name: 'Kilograms', Abbreviation: 'kg' },
  { QuantityType: 'VolumeBased', Name: 'Liters', Abbreviation: 'l' },
  { QuantityType: 'WeightBased', Name: 'Milligrams', Abbreviation: 'mg' },
  { QuantityType: 'VolumeBased', Name: 'Milliliters', Abbreviation: 'ml' },
  { QuantityType: 'WeightBased', Name: 'Ounces', Abbreviation: 'oz' },
  { QuantityType: 'VolumeBased', Name: 'Pints', Abbreviation: 'pt' },
  { QuantityType: 'WeightBased', Name: 'Pounds', Abbreviation: 'lb' },
  { QuantityType: 'VolumeBased', Name: 'Quarts', Abbreviation: 'qt' },
];

export type UnitOption = {
  label: string;
  value: string;
  quantityType: QuantityType;
};

export const UNITS_OF_MEASURE_OPTIONS: UnitOption[] = UNITS_OF_MEASURE.map((u) => ({
  label: `${u.Name} (${u.Abbreviation})`,
  value: u.Abbreviation,
  quantityType: u.QuantityType,
})).sort((a, b) => a.label.localeCompare(b.label, undefined, { sensitivity: 'base' }));

export const filterUnitsByQuantityType = (quantityType: QuantityType): UnitOfMeasure[] =>
  UNITS_OF_MEASURE.filter((u) => u.QuantityType === quantityType);
